import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatRupiah(value) {
  const n = Number(value || 0);
  return "Rp " + n.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

export const KATEGORI = {
  sealed: { label: "Sealed Product", cls: "bg-indigo-500/10 text-indigo-300 border-indigo-500/30" },
  raw: { label: "Raw Cards", cls: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
  slab: { label: "Slab / Graded", cls: "bg-amber-500/10 text-amber-300 border-amber-500/30" },
};

export const FRANCHISES = [
  "Pokemon",
  "One Piece",
  "Yu-Gi-Oh!",
  "Magic: The Gathering",
  "Dragon Ball",
  "Lorcana",
  "Lainnya",
];

export const FRANCHISE_CLS = {
  Pokemon: "bg-yellow-500/10 text-yellow-300 border-yellow-500/30",
  "One Piece": "bg-red-500/10 text-red-300 border-red-500/30",
  "Yu-Gi-Oh!": "bg-amber-600/10 text-amber-400 border-amber-600/30",
  "Magic: The Gathering": "bg-purple-500/10 text-purple-300 border-purple-500/30",
  "Dragon Ball": "bg-orange-500/10 text-orange-300 border-orange-500/30",
  Lorcana: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
  Lainnya: "bg-slate-500/10 text-slate-300 border-slate-500/30",
};
